import { useRef } from 'react';

const albums = [
  {
    id: 1,
    title: 'JOY + PAIN',
    releaseDate: 'January 2025',
    cover: 'https://static.readdy.ai/image/65bc6cd4bf89e9871e78f57376195ee1/08098b08ed8992e1312206692e2451a6.jpeg',
    featured: true,
    spotifyUrl: 'https://open.spotify.com/track/3lOIkejo02vOKwd2VkSHMg?si=20b72bee520d4978',
    appleMusicUrl: 'https://music.apple.com/us/song/joy-pain-feat-bo-roc/1861236093',
    tidalUrl: 'https://tidal.com/track/481517446/u'
  },
  {
    id: 2,
    title: 'Pull Up',
    releaseDate: 'December 2024',
    cover: 'https://static.readdy.ai/image/65bc6cd4bf89e9871e78f57376195ee1/031635db2ee2bf365e45bba2230ccf97.png',
    featured: false,
    spotifyUrl: 'https://open.spotify.com/track/08Yu67jjdzDWNfD4Q8Lw1Y?si=3daf09c4c52e41f0',
    appleMusicUrl: 'https://music.apple.com/us/song/pull-up-feat-e-d-i-mean/1806224400',
    tidalUrl: 'https://tidal.com/album/427855562/u'
  },
  {
    id: 3,
    title: 'HOOD NIGGA',
    releaseDate: 'August 2024',
    cover: 'https://static.readdy.ai/image/65bc6cd4bf89e9871e78f57376195ee1/167d4c3503cdd8a3ee570591d29f9ed4.png',
    featured: false,
    spotifyUrl: 'https://open.spotify.com/track/0GEbcQpLtw4Qg8z9fYPkFG?si=ef36cdc33916455f',
    appleMusicUrl: 'https://music.apple.com/ng/song/hood-nigga/1811211203'
  },
  {
    id: 4,
    title: "YESTERDAY'S PRYCE",
    releaseDate: 'May 2024',
    cover: 'https://static.readdy.ai/image/65bc6cd4bf89e9871e78f57376195ee1/4810795e59274a64cd9a086260592613.png',
    featured: false,
    spotifyUrl: 'https://open.spotify.com/track/1a2XxyxvRy7AvqdkTt4r7V?si=439e8721d6dd4ed8',
    appleMusicUrl: 'https://music.apple.com/ng/song/yesterdays-pryce-feat-technic-tha-realest/1822868569',
    tidalUrl: 'https://tidal.com/track/444342421/u'
  },
  {
    id: 5,
    title: 'ALL IN',
    releaseDate: 'February 2024',
    cover: 'https://static.readdy.ai/image/65bc6cd4bf89e9871e78f57376195ee1/f495d027f7cf2e94cb7eccc847e55352.jpeg',
    featured: false,
    spotifyUrl: 'https://open.spotify.com/track/6ZXJ1RHbWWNiyLR8GUBl9d?si=39a822371397402b',
    appleMusicUrl: 'https://music.apple.com/ng/album/all-in-feat-tha-realest-single/1844877437'
  }
];

export default function Music() {
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: 'left' | 'right') => {
    if (scrollContainerRef.current) {
      const scrollAmount = 300;
      scrollContainerRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="music" className="py-32 px-6 lg:px-20 bg-zinc-950 relative overflow-hidden">
      {/* Grid Pattern Overlay */}
      <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: 'linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)',
        backgroundSize: '50px 50px'
      }}></div>

      <div className="max-w-7xl mx-auto relative z-10">
        {/* Section Title */}
        <div className="mb-16">
          <h2 className="text-6xl lg:text-7xl font-thin text-white tracking-tight">
            LATEST <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-600">RELEASES</span>
          </h2>
        </div>

        {/* Albums Scroll Container */}
        <div className="relative">
          {/* Scroll Buttons */}
          <button
            onClick={() => scroll('left')}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 z-20 w-12 h-12 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:bg-white/20 transition-all duration-300"
          >
            <i className="ri-arrow-left-line text-xl"></i>
          </button>
          <button
            onClick={() => scroll('right')}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 z-20 w-12 h-12 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:bg-white/20 transition-all duration-300"
          >
            <i className="ri-arrow-right-line text-xl"></i>
          </button>

          <div
            ref={scrollContainerRef}
            className="flex gap-8 overflow-x-auto scrollbar-hide scroll-smooth pb-4"
            style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
          >
            {albums.map((album) => (
              <div
                key={album.id}
                className="flex-shrink-0 group cursor-pointer w-[280px]"
              >
                <div className="relative">
                  <div className={`relative overflow-hidden rounded-xl h-[280px] transition-all duration-500 group-hover:shadow-2xl ${
                    album.featured 
                      ? 'group-hover:shadow-red-500/50' 
                      : 'group-hover:shadow-cyan-400/50'
                  }`}>
                    <img
                      src={album.cover}
                      alt={album.title}
                      className="w-full h-full object-cover object-top transform group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  </div>
                </div>

                <div className="mt-4">
                  <h3 className="text-lg font-bold text-white mb-2">{album.title}</h3>
                  
                  <div className="flex items-center gap-3">
                    <a href={album.spotifyUrl} target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-green-500 transition-colors duration-300">
                      <i className="ri-spotify-fill text-xl"></i>
                    </a>
                    <a href={album.appleMusicUrl} target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-red-500 transition-colors duration-300">
                      <i className="ri-apple-fill text-xl"></i>
                    </a>
                    {album.tidalUrl && (
                      <a href={album.tidalUrl} target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-cyan-400 transition-colors duration-300">
                        <i className="ri-music-fill text-xl"></i>
                      </a>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* View All Link */}
        <div className="mt-12 text-center">
          <a href="https://open.spotify.com/artist/19027wmWbWJxkzgCA2iV7h?si=Sxwfr4CgQQe5b5AuwmZMFQ" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-red-500 text-lg font-semibold hover:gap-4 transition-all duration-300">
            VIEW ALL MUSIC
            <i className="ri-arrow-right-line text-cyan-400"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
